import React from "react";
import styles from "./add-tokens-modal.module.scss";
import { Input, InputNumber, Select } from "antd";
import { DownOutlined } from "@ant-design/icons";

interface Props {
  closeModal?: (args: { fetchUserDetails: boolean }) => void;
  user: any;
  newCredits: number;
  decreaseValue: () => void;
  increaseValue: () => void;
  setNewValue: (value: number) => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
  feature: "chat" | "assistant";
  setFeature: (value: "chat" | "assistant") => void;
}

export const AddTokens: React.FC<Props> = ({
  closeModal,
  user,
  newCredits,
  decreaseValue,
  increaseValue,
  setNewValue,
  onConfirm,
  isSubmitting,
  feature,
  setFeature,
}) => {
  const assignedToLabel =
    user?.name || user?.account_holder || user?.email || "Assigned user";

  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <h3 className={styles.modalHeaderTitle}>Add Credits</h3>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => closeModal({ fetchUserDetails: false })}
        >
          <span className={styles.modalHeaderClose}>×</span>
        </div>
      </div>
      <div className={styles.modalBody}>
        <div className={styles.modalBodyCredits}>
          <p className={styles.modalBodyCreditsLabel}>Add Credits</p>
          <div className={styles.modalBodyCounter}>
            <button
              className={styles.modalBodyCounterButtons}
              onClick={decreaseValue}
              type="button"
              aria-label="Decrease credits"
            >
              -
            </button>
            <InputNumber
              className={styles.modalBodyCounterText}
              value={newCredits}
              min={0}
              step={10}
              controls={false}
              onChange={(val) => {
                if (typeof val === "number") setNewValue(Math.floor(val));
              }}
            />
            <button
              className={styles.modalBodyCounterButtons}
              onClick={increaseValue}
              type="button"
              aria-label="Increase credits"
            >
              +
            </button>
          </div>
        </div>
        <div className={styles.modalBodyField}>
          <p className={styles.modalBodyFieldLabel}>Assigned To</p>
          <pre>{assignedToLabel}</pre>
        </div>
        <div className={styles.modalBodyField}>
          <p className={styles.modalBodyFieldLabel}>Feature</p>
          <Select
            value={feature}
            onChange={(value) => setFeature(value as "chat" | "assistant")}
            className={styles.modalBodySelectInput}
            options={[
              { value: "chat", label: "Search" },
              { value: "assistant", label: "Assistants" },
            ]}
            suffixIcon={<DownOutlined />}
          />
        </div>
      </div>
      <div className={styles.modalButtonWrap}>
        <button
          className={[styles.modalButton, styles.modalButtonCancel].join(" ")}
          onClick={() => closeModal({ fetchUserDetails: false })}
        >
          Cancel
        </button>
        <button
          className={styles.modalButton}
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};
